var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"image-loader-loading",style:(_vm.loadingStyle)},[_c('img',{ref:"image",staticClass:"image",style:(_vm.imageStyle),attrs:{"src":_vm.src},on:{"load":_vm.imageLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }